var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup7232(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 30,
    viewBox: "0 0 6 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#14142B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 15,
    r: 3,
    fill: "#14142B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 27,
    r: 3,
    fill: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7232);
export default __webpack_public_path__ + "static/media/Group 7232.06f336bc9c8bd38fdaf5d41de557789a.svg";
export { ForwardRef as ReactComponent };